

export const Events = {
    PL_SEND_REQUEST_UPDATED : "Project lead updated an already sent request",
    TL_REQUEST_STATUS_UPDATED : "Lead lead has updated the request"
};